import { render } from "./OrderPaidBanner.vue?vue&type=template&id=55e7b144"
import script from "./OrderPaidBanner.vue?vue&type=script&lang=js"
export * from "./OrderPaidBanner.vue?vue&type=script&lang=js"
script.render = render

export default script